<template>
    <form-wizard title="" subtitle="" color="#3F6CB1" displayPrevButton="false">
        <template v-slot:step="props">
            <wizard-step
                :tab="props.tab"
                :transition="props.transition"
                :index="props.index">
            </wizard-step>
        </template>
        <tab-content title="Start" icon="fas fa-lg fa-play" :before-change="createUpdate">
            <h3>Allgemeine Angaben</h3>
            <p>Bitte tragen Sie einen beschreibenden Namen für dieses Update ein (z.B. "2010 - 08"):</p>
            <form :model="step1" @submit.prevent>
                <div class="form-group">
                    <label for="name">Updatebezeichnung</label>
                    <input
                        type="text"
                        :class="{'form-control': true, 'is-valid' : (hasErrors && typeof errors['name'] === typeof undefined), 'is-invalid' : (typeof errors['name'] !== typeof undefined)}"
                        v-model="step1.name"
                    />
                </div>
            </form>
        </tab-content>
        <tab-content title="Datenupload" icon="fas fa-lg fa-file-upload" :before-change="checkUpload">
            <h3>Upload der Daten</h3>
            <p>Bitte wählen Sie nun im unten stehendem Formular die *.zip-Datei aus welche die Update-Daten enthält.</p>
            <form :model="step1" @submit.prevent>
                <div class="form-group">
                    <div class="input-group mb-3">
                        <div class="custom-file" v-show="!uploading">
                            <input
                                type="file"
                                :class="{'custom-file-input': true, 'is-valid' : (!hasErrors && update.file !== ''), 'is-invalid' : (hasErrors)}"
                                id="inputGroupFile"
                                @change="filesChange($event.target.files); fileCount = $event.target.files.length"
                            />
                            <label class="custom-file-label" for="inputGroupFile">
                                {{ (step2.files !== '' && step2.files !== null) ? step2.files[0].name : 'Datei auswählen'}}
                            </label>
                        </div>
                        <div class="input-group-append" v-show="!uploading">
                            <span v-on:click="uploadFile" class="btn btn-outline-secondary">Datei hochladen</span>
                        </div>
                        <div class="v-spinner" v-show="uploading">
                            <div class="v-sync v-sync1"></div>
                            <div class="v-sync v-sync2"></div>
                            <div class="v-sync v-sync3"></div>
                        </div>
                    </div>
                </div>
            </form>
            <div v-if="hasErrors" class="alert alert-danger" role="alert">
                <p>{{errors.general}}</p>
            </div>
            <p>Die benötigte Zeit zum Upload der Datei kann aufgrund seiner Größe varieren und ein paar Minuten in Anspruch nehmen. Bitte unterbrechen Sie nicht diesen Vorgang!</p>
        </tab-content>
        <tab-content title="Buchungen" icon="fas fa-lg fa-file-invoice-dollar" :before-change="importBookings">
            <div v-if="showProgress" class="progress">
                <div class="progress-bar" role="progressbar" :style="'width:' + progress + '%'" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        </tab-content>
        <tab-content title="Allgemeine Daten" icon="fas fa-lg fa-table" :before-change="importGeneralData">
            <div class="alert alert-success" role="alert">
                <p>Es wurden {{step3.anzahlRechnungenDone}} von {{step3.anzahlRechnungen}} Rechnungen und {{step3.anzahlVorgaengeDone}} von {{step3.anzahlVorgaenge}} Vorgängen importiert.</p>
            </div>
            <div v-if="showProgress" class="progress">
                <div class="progress-bar" role="progressbar" :style="'width:' + progress + '%'" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        </tab-content>
        <tab-content title="Ladevorgänge" icon="fas fa-lg fa-charging-station" :before-change="importChargingTransactions">
            <div class="alert alert-success" role="alert">
                <p>{{ step4.anzahlWochenprogramme }} von {{ step4.anzahlWochenprogrammeDone }} Wochenprogrammen wurden importiert.</p>
                <p>{{ step4.anzahlWochenprogrammschritte }} von {{ step4.anzahlWochenprogrammschritteDone }} Wochenprogrammschritten wurden importiert.</p>
            </div>
            <div v-if="showProgress" class="progress">
                <div class="progress-bar" role="progressbar" :style="'width:' + progress + '%'" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        </tab-content>
        <tab-content title="Fahrradvorgänge" icon="fas fa-lg fa-bicycle" :before-change="importBikeTransactions">
            <div class="alert alert-success" role="alert" v-if="!hasErrors">
                <p>Es wurden {{step5.anzahlChargingTransactionsImported}} von {{step5.anzahlChargingTransactions}} Ladevorgänge importiert.</p>
            </div>
            <div v-if="showProgress" class="progress">
                <div class="progress-bar" role="progressbar" :style="'width:' + progress + '%'" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div v-if="hasErrors" class="alert alert-danger" role="alert">
                <p>{{errors.general}}</p>
            </div>
        </tab-content>
        <tab-content title="Import" icon="fas fa-lg fa-file-import" :before-change="importAllData">
            <div class="alert alert-success" role="alert" v-if="!hasErrors">
                <p>Es wurden {{step6.anzahlBikeTransactionsImported}} von {{step6.anzahlBikeTransactions}} Fahrradvorgänge importiert.</p>
            </div>
            <div v-if="showProgress" class="progress">
                <div class="progress-bar" role="progressbar" :style="'width:' + progress + '%'" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div v-if="hasErrors" class="alert alert-danger" role="alert">
                <p>{{errors.general}}</p>
            </div>
        </tab-content>
        <tab-content title="Abschließen" icon="fas fa-lg fa-archive">
            <h2>Das Update ist abgeschlossen</h2>
            <div class="alert alert-success">
                <strong>Abgleich der Daten abgeschlossen.</strong><br/>
            </div>
        </tab-content>
        <template v-slot:footer="props">
            <div class="wizard-footer-right">
                <wizard-button v-if="!props.isLastStep" @click="props.nextTab()" :class="{'wizard-footer-right': true, 'update-button ': true, 'loading': showProgress}">Weiter</wizard-button>
                <wizard-button v-else @click="finish()" :class="{'wizard-footer-right': true, 'update-button ': true, 'loading': showProgress, 'finish-button': true}">Abschließen</wizard-button>
            </div>
        </template>
    </form-wizard>
</template>

<script>
    /* This component has not been ported to the Composition API because it is HUGE, and complicated, and
    * a piece of critical infrastructure for the monthly billing calcualations?
    * I didn't want to bork something that's difficult to test, porting to a different plugin is virtually impossible,
    * so I would need to completely rethink this. Keeping the component, just porting it to Vue 3, should be enough for now.
    * Dec. 2023
    */

    import axios from 'axios'
    // This UpdateComponent uses a form wizard which runs an action before the next step is executed.
    // The executed action is defined by the current step number.
    export default {
        props: {
            createUrl: { type: String, required: true },
            uploadUrl: { type: String, required: true },
            getProgressUrl: { type: String, required: true },
            importBookingsUrl: { type: String, required: true },
            importGeneralDataUrl: { type: String, required: true },
            importChargingTransactionsUrl: { type: String, required: true },
            importBikeTransactionsUrl: { type: String, required: true },
            importAllDataUrl: { type: String, required: true },
            finishUpdateUrl: { type: String, required: true },
        },
        data() {
            // return an initial data object
            return {
                watchCreateUrl: this.createUrl,
                watchUploadUrl: this.uploadUrl,
                watchGetProgressUrl: this.getProgressUrl,
                watchImportBookingsUrl: this.importBookingsUrl,
                watchImportGeneralDataUrl: this.importGeneralDataUrl,
                watchImportChargingTransactionsUrl: this.importChargingTransactionsUrl,
                watchImportBikeTransactionsUrl: this.importBikeTransactionsUrl,
                watchImportAllDataUrl: this.importAllDataUrl,
                watchFinishUpdateUrl: this.finishUpdateUrl,

                uploading: false,
                step1: {
                name: ''
                },
                step2: {
                files: null
                },
                step3: {},
                step4: {},
                step5: {},
                step6: {},
                step7: {},
                showProgress: false,
                progress: 0,
                update: {
                id: 0,
                file: '',
                status: 0,
                },
                errors: {},
                color: '#3F6CB1',
                hasErrors: false
            }
        },
        watch: {
            createUrl: {
                handler: function(createUrl) {
                    this.watchCreateUrl = createUrl
                },
                immediate: true
            },
            uploadUrl: {
                handler: function(uploadUrl) {
                    this.watchUploadUrl = uploadUrl
                },
                immediate: true
            },
            getProgressUrl: {
                handler: function(watchGetProgressUrl) {
                    this.watchGetProgressUrl = watchGetProgressUrl
                },
                immediate: true
            },
            importBookingsUrl: {
                handler: function(importBookingsUrl) {
                    this.watchImportBookingsUrl = importBookingsUrl
                },
                immediate: true
            },
            importGeneralDataUrl: {
                handler: function(importGeneralDataUrl) {
                    this.watchImportGeneralDataUrl = importGeneralDataUrl
                },
                immediate: true
            },
            importChargingTransactionsUrl: {
                handler: function(importChargingTransactionsUrl) {
                    this.watchImportChargingTransactionsUrl = importChargingTransactionsUrl
                },
                immediate: true
            },
            importAllDataUrl: {
                handler: function(importAllDataUrl) {
                    this.watchImportAllDataUrl = importAllDataUrl
                },
                immediate: true
            },
            finishUpdateUrl: {
                handler: function(finishUpdateUrl) {
                    this.watchFinishUpdateUrl = finishUpdateUrl
                },
                immediate: true
            },
            importBikeTransactionsUrl: {
                handler: function(importBikeTransactionsUrl) {
                    this.watchImportBikeTransactionsUrl = importBikeTransactionsUrl
                },
                immediate: true
            }
        },
        methods: {
            finish: function() {
                return new Promise((resolve, reject) => {
                    const req = axios.post(this.finishUpdateUrl + this.update.id).then(response => {
                        if(typeof response.data.message !== typeof undefined) {
                            window.location.href=document.baseURI + 'updates/' + this.update.id + '/details';
                        } else {
                            reject('Something went wrong!');
                        }
                    }).catch(error => {
                        this.progress = 0;
                        this.showProgress = false;
                        if (error.response.status === 422) {
                            this.hasErrors = Object.keys(error.response.data).length;
                            this.errors = error.response.data || {
                                'general': error.response.data.message
                            };
                        } else {
                            this.hasErrors = 1;
                            this.errors = {
                                'general': error.response.data.message
                            };
                        }
                        reject('Something went wrong!');
                    });
                    return req;
                });
            },
            importAllData: function() {
                return new Promise((resolve, reject) => {
                    this.showProgress = true;
                    this.progress = 0;
                    var timer = setInterval(() => {
                        axios.get(this.getProgressUrl + this.update.id).then(response => {
                            this.progress = response.data;
                        });
                    }, 3000);
                    const req = axios.post(this.importAllDataUrl + this.update.id).then(response => {
                        this.showProgress = false;
                        this.step7 = response.data;
                        this.progress = 0;
                        clearInterval(timer);
                        resolve(true);
                    }).catch(error => {
                        this.progress = 0;
                        this.showProgress = false;
                        clearInterval(timer);
                        if (error.response.status === 422) {
                            this.hasErrors = Object.keys(error.response.data).length;
                            this.errors = error.response.data || {
                                'general': error.response.data.message
                            };
                        } else {
                            this.hasErrors = 1;
                            this.errors = {
                                'general': error.response.data.message
                            };
                        }
                        // Same as with users, this is likely to take more than 5 minutes so ignore errors here as well. But only in case of 500 error
                        // Not a good idea but for now this seems to be the fastes way to get around the problem
                        // Sets the next button to move on even though it isn't finished. Must wait till no new entries are going to the database before cklicking next
                        if (error.response.status === 504) {
                            resolve(true);
                        }else{
                            reject('Something went wrong!');
                                }
                    });
                    return req;
                });
            },
            importChargingTransactions: function() {
                return new Promise((resolve, reject) => {
                    this.showProgress = true;
                    this.progress = 0;
                    var timer = setInterval(() => {
                        axios.get(this.getProgressUrl + this.update.id).then(response => {
                            this.progress = response.data;
                        });
                    }, 3000);
                    const req = axios.post(this.importChargingTransactionsUrl + this.update.id).then(response => {
                        this.showProgress = false;
                        this.step5 = response.data;
                        this.progress = 0;
                        clearInterval(timer);
                        resolve(true);
                    }).catch(error => {
                        this.showProgress = false;
                        this.progress = 0;
                        clearInterval(timer);
                        reject('Something went wrong!');
                    });
                    return req;
                });
            },
            importBikeTransactions: function() {
                return new Promise((resolve, reject) => {
                    this.showProgress = true;
                    this.progress = 0;
                    var timer = setInterval(() => {
                        axios.get(this.getProgressUrl + this.update.id).then(response => {
                            this.progress = response.data;
                        });
                    }, 3000);
                    const req = axios.post(this.importBikeTransactionsUrl + this.update.id).then(response => {
                        this.showProgress = false;
                        this.step6 = response.data;
                        this.progress = 0;
                        clearInterval(timer);
                        resolve(true);
                    }).catch(error => {
                        this.showProgress = false;
                        this.progress = 0;
                        clearInterval(timer);
                        reject('Something went wrong!');
                    });
                    return req;
                });
            },
            importGeneralData: function() {
                return new Promise((resolve, reject) => {
                    this.showProgress = true;
                    this.progress = 0;
                    var timer = setInterval(() => {
                        axios.get(this.getProgressUrl + this.update.id).then(response => {
                            this.progress = response.data;
                        });
                    }, 3000);
                    const req = axios.post(this.importGeneralDataUrl + this.update.id).then(response => {
                        this.showProgress = false;
                        this.step4 = response.data;
                        this.progress = 0;
                        clearInterval(timer);
                        resolve(true);
                    }).catch(error => {
                        this.showProgress = false;
                        this.progress = 0;
                        clearInterval(timer);
                        reject('Something went wrong!');
                    });
                    return req;
                });
            },
            importBookings: function() {
                return new Promise((resolve, reject) => {
                    this.showProgress = true;
                    this.progress = 0;
                    var timer = setInterval(() => {
                        axios.get(this.getProgressUrl + this.update.id).then(response => {
                            this.progress = response.data;
                        });
                    }, 3000);
                    const req = axios.post(this.importBookingsUrl + this.update.id).then(response => {
                        this.showProgress = false;
                        this.step3 = response.data;
                        this.progress = 0;
                        clearInterval(timer);
                        resolve(true);
                    }).catch(error => {
                        this.showProgress = false;
                        this.progress = 0;
                        clearInterval(timer);
                        reject('Something went wrong!');
                    });
                    return req;
                });
            },
            createUpdate: function() {
                return new Promise((resolve, reject) => {
                    return axios.post(this.createUrl, { name: this.step1.name }).then(response => {
                        if(response.status === 201) {
                            this.update.status++;
                            this.update.id = response.data.id;
                            this.update.status = response.data.status;
                            if(this.update.id && this.update.id !== 0) {
                                resolve(true);
                            }
                        }
                    }).catch(error => {
                        if (error.response.status === 422) {
                            this.hasErrors = Object.keys(error.response.data).length;
                            this.errors = error.response.data || {
                                'general': error.response.data.message
                            };
                        } else {
                            this.hasErrors = 1;
                            this.errors = {
                                'general': error.response.data.message
                            };
                        }
                        reject('Something went wrong!');
                    });
                });
            },
            checkUpload: function() {
                return new Promise((resolve, reject) => {
                    if(this.update.file !== '') {
                        resolve(true);
                    } else {
                        reject('No file seems to be uploaded!');
                    }
                });
            },
            filesChange(files) {
                this.step2.files = files;
            },
            uploadFile() {
                return new Promise((resolve, reject) => {
                    this.uploading = true;
                    const formData = new FormData();

                    if (!this.step2.files || !this.step2.files.length) return;

                    formData.append('file', this.step2.files[0], this.step2.files[0].name);

                    return axios({
                        method: 'POST',
                        url: this.uploadUrl + this.update.id,
                        data: formData,
                        config: { headers: {'Content-Type': 'multipart/form-data' }}
                    })
                    .then((response) => {
                        this.uploading = false;
                        this.update.file = response.data.file;
                        this.update.status = response.data.status;
                        this.hasErrors = 0;
                        this.errors = {};
                    })
                    .catch((error) => {
                        this.uploading = false;
                        if (error.response.status === 422) {
                            this.hasErrors = Object.keys(error.response.data).length;
                            this.errors = error.response.data || {
                                'general': error.response.data.message
                            };
                        } else {
                            this.hasErrors = 1;
                            this.errors = {
                                'general': error.response.data.message
                            };
                        }
                        reject('Something went wrong!');
                    });
                });
            }
        }
    }
</script>
